import React, { useEffect, useState } from 'react';
import { getItem, formatShortDate, toDateInputValue } from '../../utils';
import { getEntityByListAction } from '../../constants';

const EntityEditForm = ({
  fields = {},
  schema = {},
  onSaveField,
  getOptionLabel = (k, v) => v,
  listType,
  selectedDate,
  memberTypeNames = []
}) => {
  const [editingField, setEditingField] = useState(null);
  const [editValue, setEditValue] = useState('');
  const [fetchStatus, setFetchStatus] = useState({});

  useEffect(() => {
    setEditingField(null);
  }, [fields]);

  const handleEditClick = (field) => {
    const fieldType = schema[field]?.type || schema[field]?.[1] || 'text';
    setEditingField(field);
    setEditValue(fieldType === 'date' ? toDateInputValue(fields[field]) : (fields[field] ?? ''));
  };

  const handleSaveClick = async (field) => {
    try {
      if (onSaveField) {
        await onSaveField(field, editValue);
      } else {
        const entity = getEntityByListAction(listType);
        const conditionKey = entity?.conditionKey || (fields.email ? 'email' : Object.keys(schema)[0]);
        const conditionValue = fields[conditionKey] !== undefined ? fields[conditionKey] : (fields.email ? fields.email : fields[Object.keys(schema)[0]]);

        const response = await getItem({
          action: 'edit-item',
          listType,
          conditionKey,
          conditionValue,
          date: formatShortDate(selectedDate, 'unformated'),
          [field]: editValue
        });
        if (!response || !response.success) {
          throw new Error('Save failed');
        }
      }

      setEditingField(null);
      setFetchStatus({ [field]: 'success' });
      setTimeout(() => setFetchStatus((prev) => ({ ...prev, [field]: null })), 2000);
    } catch (error) {
      console.error('Error saving field:', error);
      setFetchStatus({ [field]: 'error' });
    }
  };

  const getFieldOptions = (key, fieldDef) => {
    if (fieldDef?.options) return fieldDef.options;
    if (fieldDef?.optionsSource === 'memberTypeNames' && Array.isArray(memberTypeNames)) {
      return ['Välj', ...memberTypeNames.map((m) => m.id)];
    }
    if (fieldDef && fieldDef[2]) return fieldDef[2];
    return null;
  };

  if (!fields) return null;

  return (
    <div id="profile-form" className="flex flex-column">
      {Object.entries(schema).map(([key]) => {
        const options = getFieldOptions(key, schema[key]);
        const fieldType = schema[key]?.type || schema[key]?.[1] || 'text';
        const fieldLabel = schema[key]?.label || schema[key]?.[0] || key;
        const isReadOnly = schema[key]?.readOnly || editingField !== key;

        return (
          <div key={key} className="flex flex-wrap">
            <label htmlFor={`edit-field-${key}`}>{fieldLabel}</label>
            <div className="flex flex-align-center-h edit-input-wrapper">
              {options ? (
                <select
                  id={`edit-field-${key}`}
                  value={editingField === key ? editValue : (fields[key] ?? '')}
                  onChange={(e) => {
                    setEditValue(e.target.value);
                    setEditingField(key);
                  }}
                >
                  {options.map((option) => (
                    <option key={option} value={option}>
                      {getOptionLabel(key, option)}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  id={`edit-field-${key}`}
                  type={fieldType}
                  value={
                    fieldType === 'date'
                      ? toDateInputValue(editingField === key ? editValue : (fields[key] ?? ''))
                      : (editingField === key ? editValue : (fields[key] ?? ''))
                  }
                  onChange={(e) => setEditValue(e.target.value)}
                  readOnly={isReadOnly}
                  onClick={() => !schema[key]?.readOnly && handleEditClick(key)}
                />
              )}
              {!schema[key]?.readOnly && (
                <span onClick={() => handleEditClick(key)} style={{ cursor: 'pointer', marginRight: '10px' }}>
                  ✏️
                </span>
              )}
              {editingField === key && (
                <span onClick={() => handleSaveClick(key)} style={{ cursor: 'pointer', marginRight: '10px' }}>
                  💾
                </span>
              )}
              {fetchStatus[key] === 'success' && (
                <span style={{ color: 'green', marginLeft: '10px' }}>✔️</span>
              )}
              {fetchStatus[key] === 'error' && (
                <span style={{ color: 'red', marginLeft: '10px' }}>❌</span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default EntityEditForm;
export { EntityEditForm };
